import React from "react";
import { Badge } from "react-bootstrap";

const RetargetPerformanceCard = ({ data }) => {
  const metrics = data?.retarget_metrics || {};
  const voucher = metrics.voucher || {};
  const engagement = metrics.engagement || {};
  const overall = metrics.overall || {};

  const totalRevenue = overall.total_revenue || 0;
  const totalCost = overall.total_cost || 0;
  const roi = overall.roi_percent || 0;

  return (
      <div className="card p-3 rounded-4 shadow-sm">

        {/* 🔝 HEADER */}
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Badge className={`px-2 py-1 border font8-bdg bg-warning-subtle text-dark mb-2`}
            >
                Performance
            </Badge>
            <h4 className="mb-3 font-bold">KES {totalRevenue.toLocaleString()}</h4>
          </div>

          <div
            className={`px-2 py-1 rounded-pill mt-3 small ${
              roi > 0 ? "bg-success-subtle text-success" : "bg-light text-muted"
            }`}
          >
            {roi.toFixed(0)}% ROI
          </div>
        </div>

        {/* 💰 PROFIT */}
        <div className="text-success small mb-3">
          +KES {(totalRevenue - totalCost).toLocaleString()} profit
        </div>

        {/* 📊 KPI ROW */}
        <div className="row g-2 mb-3">

          <div className="col-6">
            <div className="p-2 rounded-3 bg-lblue border-dlblue">
              <div className="text-muted small">Cost</div>
              <div className="fw-semibold">
                KES {totalCost.toLocaleString()}
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="p-2 rounded-3 bg-lblue border-dlblue">
              <div className="text-muted small">Conversion</div>
              <div className="fw-semibold">
                {voucher.conversion_rate?.toFixed(0) || 0}%
              </div>
            </div>
          </div>

        </div>

        {/* 📦 BREAKDOWN */}
        <div className="border-top pt-2 mb-3">

          {/* Voucher */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div>
              <div className="small fw-semibold">Vouchers</div>
              <div className="text-muted small">
                {voucher.total_rewards_redeemed || 0} /{" "}
                {voucher.total_rewards_issued || 0}
              </div>
            </div>

            <div className="text-end small">
              <div className="fw-semibold">
                KES {voucher.revenue?.toLocaleString() || 0}
              </div>
              <div className="text-muted">
                {voucher.roi_percent?.toFixed(0) || 0}% ROI
              </div>
            </div>
          </div>

          {/* SMS */}
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <div className="small fw-semibold">SMS</div>
              <div className="text-muted small">
                {engagement.sms_converted || 0} /{" "}
                {engagement.sms_sent || 0}
              </div>
            </div>

            <div className="text-end small">
              <div className="fw-semibold">
                KES {engagement.revenue?.toLocaleString() || 0}
              </div>
              <div className="text-muted">
                {engagement.roi_percent?.toFixed(0) || 0}% ROI
              </div>
            </div>
          </div>

        </div>

      </div>
  );
};

export default RetargetPerformanceCard;